var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 981.9 981.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M861 863.05c0-30.4-24.6-55-55-55H175.9c-30.4 0-55 24.6-55 55s24.6 55 55 55H806c30.4 0 55-24.7 55-55zM65.4 417.85c.9 0 1.7 0 2.6-.1l87.2 315.6h671.5l87.2-315.6c.899 0 1.699.1 2.6.1 36.1 0 65.4-29.3 65.4-65.4s-29.301-65.4-65.4-65.4-65.4 29.3-65.4 65.4c0 7 1.101 13.8 3.2 20.1l-157.7 92.2-169.5-281c17.601-11.7 29.301-31.8 29.301-54.5 0-36.1-29.301-65.4-65.4-65.4s-65.4 29.3-65.4 65.4c0 22.8 11.601 42.8 29.301 54.5l-169.5 281-157.7-92.2c2-6.3 3.2-13.1 3.2-20.1 0-36.1-29.3-65.4-65.4-65.4-36.2 0-65.5 29.3-65.5 65.4s29.298 65.4 65.398 65.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.987162e7ead8b4f719b18719ef650e68.svg";
export { ForwardRef as ReactComponent };